export const OBJECT_NAMES = {
  PAPER_CRANE: 'Paper Crane',
  ORIGAMI: 'Origami',
  LIGHTS_MANAGER: 'LightsManager',
  DIRECTIONAL_LIGHT_1: 'DirectionaLight 1',
  DIRECTIONAL_LIGHT_2: 'DirectionaLight 2',
  AMBIENT_LIGHT_1: 'Ambient Light 1'
};
